const forEmployersResources = {
    title: 'For Employers',
};
export default forEmployersResources;